// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"114":"9a583f1d","788":"0cc57eba"}[chunkId] + ".chunk.js";
};